import React, { useState } from 'react';
import { Button, Text, View, Avatar, NativeBaseProvider, Divider } from 'native-base';
import { FontAwesome } from '@expo/vector-icons';
import { liveTTScoreboardButtonTextColor } from '../../../livettscoreboard.config';
import { liveTTScoreboardTheme } from "../../liveTTScoreboardTheme";

export function PreLoadedPlayerItem(props) {
    let [isSelected, setIsSelected] = useState(props.isSelected);
    let [isDeleted, setIsDeleted] = useState(false);
    console.log(props);


    return (
        <NativeBaseProvider theme={liveTTScoreboardTheme}>
            <View>
                {/* <TouchableOpacity
    onPress={ () =>{
        console.log(props.item)
        if(!isSelected && typeof props.id =="undefined"){
            console.log("isSelected is not entered")
           db.ref("tournaments/"+props.route.params["tournamentID"]+"/predefinedplayers").push({

            firstName:props.firstName,
            lastName:props.lastName,
            imageURL: props.imageURL
        })
        setIsSelected(true)
        }
        // else if(!props.item.isSelected){
        //     console.log("isSelected is false")
        //     db.ref("tournaments").child(this.props.route.params["tournamentID"]).child("predefinedplayers").child(props.item.id).update({isSelected:true})

        // }
        else{

            console.log("isSelected is true")
            db.ref("tournaments/"+props.route.params["tournamentID"]+"/predefinedplayers/"+props.id).remove()
            setIsSelected(false)
            //update({isSelected:false})
        }
       
        
    }}
    > */}
                <View padding={2} justifyContent={"space-between"} alignItems={"center"} flexDirection={"row"}>
                    <View alignItems={"center"} flexDirection={"row"}>
                        {props.imageURL && props.imageURL.length > 0 ?
                            <View padding={1}>
                                <Avatar square source={{ uri: props.imageURL }}></Avatar>
                            </View>
                            : null}
                        <Text fontSize={"lg"} fontWeight="bold">{props.firstName + " " + props.lastName}</Text>
                    </View>
                    <View style={{ flexDirection: "row" }}>
                        <View padding={1}>
                            <Button
                                onPress={() => {
                                    props.onEdit(props.selectedPlayer);
                                }}
                            >
                                <FontAwesome color={liveTTScoreboardButtonTextColor} name="edit"></FontAwesome>
                            </Button>
                        </View>
                        <View padding={1}>
                            <Button onPress={() => {
                                props.onDelete(props.selectedPlayer);
                            }}>
                                <FontAwesome color={liveTTScoreboardButtonTextColor} name="trash"></FontAwesome>
                            </Button>
                        </View>
                        {/* {
        isSelected ?
    <Text style={{color:"#3968CC"}}>{"Player is added to this tournament. \u2713"}</Text>

        :<Text style={{color:"#990000"}}>Click here to add this player.</Text>
    } */}
                    </View>
                </View>



                {/* </TouchableOpacity>  */}
            </View>

            <Divider></Divider>
        </NativeBaseProvider>

    );



}
